import { Icon } from "@components/icon";
import * as types from "@root/types";
import React, { type FC } from "react";

interface PaletteEntryProps {
  icon: types.IconName;
}

const PaletteEntry: FC<PaletteEntryProps> = ({ icon }) => {
  return (
    <div className="palette-entry">
      <Icon name={icon} />
      <div className="palette-entry__class">{icon}</div>
    </div>
  );
};

export { PaletteEntry };
